import React, { useState } from "react";
import { FaDownload, FaSearch } from "react-icons/fa";
import { getInitialDate, toISODateInput } from "../../../helper/formatDate";
import { Button, FormInput } from "../../../components/ui";

import "./pharmacyDistributionHeader.css";

/**
 * @typedef {Object} PharmacyDistributionFormSchema
 * @property {string} startDate
 * @property {string} endDate
 * @property {string} keyword
 * @property {string} searchStartCharacter
 */

const PharmacyDistributionHeader = ({
  onSearchButtonCliked,
  onDownloadPharmacyDistributionClicked,
}) => {
  /** @type {[PharmacyDistributionFormSchema, React.Dispatch<PharmacyDistributionFormSchema>]} */
  const [forms, setForms] = useState({
    startDate: toISODateInput(getInitialDate("daily")),
    endDate: toISODateInput(getInitialDate("daily")),
    keyword: "",
    searchStartCharacter: "",
  })

  /**
   * @param {React.ChangeEvent<HTMLInputElement>} evt 
   */
  const handleInputChange = (evt) => {
    const { value, name } = evt.target

    if (name === 'searchStartCharacter') {
      setForms((prevForms) => ({
        ...prevForms,
        searchStartCharacter: value.slice(-1).toLowerCase()
      }))
      return
    }

    setForms((prevForms) => ({
      ...prevForms,
      [name]: value
    }))
  }

  const handleSubmitForm = (evt) => {
    evt.preventDefault()
    onSearchButtonCliked(forms)
  }

  return (
    <>
      <div className="py-4 mb-3 flex justify-between items-end">
        <form className="flex items-end space-x-3" onSubmit={handleSubmitForm}>
          <div className="relative" style={{ width: '9rem' }}>
            <FormInput
              id="start-date-input"
              type="date"
              name="startDate"
              value={forms.startDate}
              max={toISODateInput(getInitialDate('daily'))}
              onChange={handleInputChange}
            />
          </div>
          <div className="relative" style={{ width: '9rem' }}>
            <FormInput
              id="end-date-input"
              type="date"
              name="endDate"
              value={forms.endDate}
              max={toISODateInput(getInitialDate('daily'))}
              onChange={handleInputChange}
            />
          </div>
          <div className="relative" style={{ width: '15rem' }}>
            <FormInput
              id="medicine-input"
              type="text"
              placeholder="Cari nama Obat"
              style={{ marginBottom: 0 }}
              name="keyword"
              value={forms.keyword}
              onChange={handleInputChange}
            />
          </div>
          <div className="relative">
            <FormInput
              id="medicine-input"
              type="text"
              placeholder="Cari berdasarkan abjad"
              style={{ marginBottom: 0 }}
              name="searchStartCharacter"
              value={forms.searchStartCharacter}
              onChange={handleInputChange}
            />
          </div>
          <div className="flex items-center space-x-3">
            <Button type="submit" variant="primary">
              <FaSearch className="mr-2" /> Cari Stok
            </Button>
            <Button type="button" variant="success" onClick={() => onDownloadPharmacyDistributionClicked()}>
              <FaDownload className="mr-2" /> Download Excel
            </Button>
          </div>
        </form>
      </div>

    </>
  );
};

export default PharmacyDistributionHeader;
